import Backbone from 'backbone';
import QuestionResults from './QuestionResults';

var QuestionResultsCollection = Backbone.Collection.extend({
    model: QuestionResults

});

export default QuestionResultsCollection;

